import { forwardRef } from "react";
import { system, typography, space, layout, flexbox, color } from "styled-system";
import styled from "styled-components";
import { CrownOutlined } from "../../icons";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const other = system({
  textTransform: true,
  whiteSpace: true
});
const StyledLabel = styled.label.withConfig({
  displayName: "label__StyledLabel",
  componentId: "sc-l7l422-0"
})(["display:inline-block;overflow:hidden;white-space:nowrap;vertical-align:middle;margin-bottom:4px;color:", ";font-size:", "px;font-weight:bold;transition:color 0.3s;", " ", " ", " ", " ", " ", ""], p => p.theme.colors.heading, p => p.theme.fontSizes.md, typography, space, layout, flexbox, color, other);
const AdminOnly = styled(CrownOutlined).withConfig({
  displayName: "label__AdminOnly",
  componentId: "sc-l7l422-1"
})(["margin-right:4px;line-height:inherit;color:", ";"], p => p.theme.colors.secondary.base);
export const Label = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    adminOnly = false,
    color,
    children,
    ...rest
  } = _ref;
  return /*#__PURE__*/_jsxs(StyledLabel, {
    ref: ref,
    title: adminOnly ? "Admin Only" : "",
    ...rest,
    color: color,
    children: [adminOnly ? /*#__PURE__*/_jsx(AdminOnly, {}) : null, children]
  });
});
export default Label;